import React, { useState } from "react";
import "./related-articles-card.scss";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

interface RelatedCardInterface {
  name: string;
  img: string;
  face: string;
  alt1: string;
  alt2: string;
  date: string;
  content: string;
  redirect: string;
}

const RelatedArticlesCard = (props: RelatedCardInterface) => {
  const { name, img, face, date, content, alt1, alt2, redirect } = props;

  const [isDisplayed, setIsDisplayed] = useState(false);

  const toggleDisplay = () => {
    setIsDisplayed(!isDisplayed);
  };

  return (
    <div className={`a-related-card ${isDisplayed ? "displayed" : ""}`}>
      <a
        className={`a-related-card__img gtmRedDeAmorContenido${normalizeTwoWords(
          name
        )}`}
        href={redirect}
      >
        <img
          className={`gtmRedDeAmorContenido${normalizeTwoWords(name)}`}
          src={img}
          alt={alt1}
        />
      </a>
      <div className="a-related-card__author">
        <img src={face} alt={alt2} />
        <h3>{name}</h3>
        <div
          className="a-related-card__author__display-btn show-on-mobile"
          onClick={() => toggleDisplay()}
        >
          <span
            className={`a-related-card__author__display-btn__line ${
              isDisplayed ? "displayed" : ""
            }`}
          ></span>
          <span className="a-related-card__author__display-btn__line"></span>
        </div>
      </div>
      <div
        className={`a-related-card__content ${
          !isDisplayed ? "hide-on-mobile" : ""
        }`}
      >
        <p className="a-related-card__content__date">{date}</p>
        <p className="a-related-card__content__description">{content}</p>
      </div>
    </div>
  );
};

export default RelatedArticlesCard;
